export default "__VITE_ASSET__BlWu1gE___"